import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const AppSearchNavPhase1 = () => import(/* webpackChunkName: "4-feat-search-nav-phase1" */ './AppSearchNavPhase1');
export default lazyLoadOnRender({ loader: AppSearchNavPhase1 });
